var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"profile_bg"},[(_vm.dadosPaciente)?_c('div',[_c('profile')],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }